import {createReducer} from "redux-act";
import {IS_SHOW_SECRET_PAGE} from "modules/constants";
import {hideSecretPage} from "modules/actions";

export interface ISecretPageReducer {
	isShowSecretPage: boolean;
}

const initialState: ISecretPageReducer = {
	isShowSecretPage: IS_SHOW_SECRET_PAGE,
};

const onHideSecretPage = (state: ISecretPageReducer) => ({
	...state,
	isShowSecretPage: false,
});

export const secretPage = createReducer<ISecretPageReducer>({}, initialState).on(
	hideSecretPage,
	onHideSecretPage
);
